export default __webpack_public_path__ + "static/media/personLaptop.c411af96.png";